import apiFetch from '../apiFetch'

export default function (list, token) {
  return apiFetch({endPoint: `Seguimiento/eliminarSeguimientoSeleccion`, method: 'POST', body: {list}, token: token})
}